import React from "react";
import "./LifeBeyond.css";

// Clubs
import roboticClub from "../assets/home-robot.jfif";
import scienceClub from "../assets/science-lab-2.jpeg";
import socialClub from "../assets/reading-club.JPG";
import culturalClub from "../assets/dance-club.JPG";
import artsAndCraftsClub from "../assets/craft-image-2.jfif";
import musicClub from "../assets/music-club.JPG";

// Events
import celebrations1 from "../assets/events-15 aug.jfif";
import celebrations2 from "../assets/events-janmasthami.jfif";
import celebrations3 from "../assets/events-performance.JPG";
import celebrations4 from "../assets/events-group.jpeg";
import celebrations5 from "../assets/events-guest.jpeg";

// Field Trips
import fieldtrip1 from "../assets/field-trip-3.jpeg";
import fieldtrip2 from "../assets/field-trip-1.jpeg";
import fieldtrip3 from "../assets/field-trip2.jpeg";

const LifeBeyond = () => {
  return (
    <div className="section alt" data-aos="fade-up">
      <h2 className="section-title reveal-text">
        Learning Beyond the Classroom
      </h2>

      {/* CLUBS & HOUSES */}
      <div className="lb-section lb-section-grid">
        <h3>Multi-Purpose Rooms , Labs , Clubs & House Activities</h3>

        <div className="lb-image-grid">
          <div className="lb-image-card">
            <img src={roboticClub} alt="Robotics Club" />
            {/*<div className="lb-image-text">Robotics Club</div>*/}
          </div>

          <div className="lb-image-card">
            <img src={scienceClub} alt="Science Club" />
            {/*<div className="lb-image-text">Science Club</div>*/}
          </div>

          <div className="lb-image-card">
            <img src={socialClub} alt="Social Club" />
            {/*<div className="lb-image-text">Social Club</div>*/}
          </div>
        </div>

        <div className="lb-image-grid">
          <div className="lb-image-card">
            <img src={culturalClub} alt="Cultural Club" />
           {/* <div className="lb-image-text">Cultural Club</div>*/}
          </div>

          <div className="lb-image-card">
            <img src={artsAndCraftsClub} alt="Arts & Crafts Club" />
            {/*<div className="lb-image-text">Arts & Crafts Club</div>*/}
          </div>

          <div className="lb-image-card">
            <img src={musicClub} alt="Music Club" />
            {/*<div className="lb-image-text">Music Club</div>*/}
          </div>
        </div>
      </div>

      {/* EVENTS & CELEBRATIONS */}
      <div className="lb-section lb-section-grid">
        <h3>Events & Celebrations</h3>

        <div className="lb-image-grid">
          <div className="lb-image-card">
            <img src={celebrations1} alt="Science Fair" />
            {/*<div className="lb-image-text">Science Fair</div>*/}
          </div>

          <div className="lb-image-card">
            <img src={celebrations2} alt="Coding Exhibition" />
            {/*<div className="lb-image-text">Coding Exhibition</div>*/}
          </div>

          <div className="lb-image-card">
            <img src={celebrations3} alt="Food Carnival" />
            {/*<div className="lb-image-text">Food Carnival</div>*/}
          </div>
        </div>

        <div className="lb-image-grid">
          <div className="lb-image-card">
            <img src={celebrations4} alt="Diwali Celebrations" />
            {/*<div className="lb-image-text">Diwali Celebrations</div>*/}
          </div>

          <div className="lb-image-card">
            <img src={celebrations5} alt="Dussehra Celebrations" />
            {/*<div className="lb-image-text">Dussehra Celebrations</div>*/}
          </div>
        </div>
      </div>

      {/* FIELD TRIPS */}
      <div className="lb-section lb-section-grid">
        <h3>Field Trips & Education Tours</h3>

        <div className="lb-image-grid">
          <div className="lb-image-card">
            <img src={fieldtrip1} alt="Museum Visit" />
            {/*<div className="lb-image-text">Museum Visit</div>*/}
          </div>

          <div className="lb-image-card">
            <img src={fieldtrip2} alt="Zoo Exploration" />
            {/*<div className="lb-image-text">Zoo Exploration</div>*/}
          </div>

          <div className="lb-image-card">
            <img src={fieldtrip3} alt="Nature Learning" />
            {/*<div className="lb-image-text">Nature Learning</div>*/}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LifeBeyond;
